let Cookies = require('../vendor/js.cookie');

/**
 * Header
 * ------
 */

if($('#site-header').length) {

    /**
     * Search Form
     */

    let searchInputDesktop = $('#search-input-desktop'),
        searchInputMobile = $('#search-input-mobile'),
        searchContainerDesktop = $('#search-container-desktop'),
        searchToggle = $('.search-toggle');

    searchToggle.on('click', function () {
        openSearchDesktop();
    });

    searchInputDesktop.on('focusout', function () {
        if($(this).val() === "") closeSearchDesktop();
    });

    function openSearchDesktop() {
        searchContainerDesktop.addClass('is-open');
        setTimeout(function () { searchInputDesktop.focus(); }, 300);
    }

    function closeSearchDesktop() {
        searchContainerDesktop.removeClass('is-open');
    }


    /**
     * Header Lock / Site Alert
     */

    let siteAlert = $('#site-alert'),
        siteAlertCloseButton = $('#site-alert-close'),
        header = $('#site-header'),
        siteWrapper = $('#main-site-wrapper'),
        menuShadow = $('#primary-dropdown-shadow-container');

    if(siteAlert.length) {

        let siteAlertVersion = parseInt(siteAlert.data('version'));

        if(Cookies.get('site-alert-closed-' + siteAlertVersion)) {
            header.imagesLoaded(function () {
                siteAlert.css('margin-top', 0 - siteAlert.outerHeight());
                siteWrapper.css('padding-top', header.outerHeight() - siteAlert.outerHeight());

                setTimeout(function () {
                    // Reset the mobile menu height
                    mobileMenu.css('height', $(window).height() - header.outerHeight());
                }, 500);
            });
        }

        siteAlertCloseButton.on('click', function () {

            siteAlert.css('margin-top', 0 - siteAlert.outerHeight());
            siteWrapper.css('padding-top', header.outerHeight() - siteAlert.outerHeight());

            setTimeout(function () {
                // Reset the mobile menu height
                mobileMenu.css('height', $(window).height() - header.outerHeight());
            }, 500);

            Cookies.set('site-alert-closed-' + siteAlertVersion);

        });

        header.imagesLoaded(function () {
            setTimeout(function () {
                if(header.hasClass('locked')) {
                    siteWrapper.css('padding-top', header.outerHeight() + $('#secondary-header-row').outerHeight());
                } else {
                    siteWrapper.css('padding-top', header.outerHeight());
                }
            }, 300);
        });

    } else {

    }

    let menuShadowOffset = (siteWrapper.outerWidth() - menuShadow.outerWidth()) / 2;
    menuShadow.css({
        'left': 0 - menuShadowOffset,
        'right': 0 - menuShadowOffset
    });

    header.toggleClass('locked', $(window).scrollTop() > 0);
    $(window).on('scroll', function () {
        if($(window).scrollTop() > 0) {
            header.addClass('locked');
        } else {
            header.removeClass('locked');
        }
    });


    /**
     * Mobile Menu
     */

    let mobileMenu = $('#mobile-menu'),
        mobileMenuToggle = $('#mobile-toggle');

    mobileMenu.css('height', $(window).height() - header.outerHeight());

    mobileMenuToggle.on('click', function () {
        if($(this).hasClass('menu-is-open')) {
            closeMobileMenu();
            $(this).removeClass('menu-is-open');
        } else {
            openMobileMenu();
            $(this).addClass('menu-is-open');
        }
    });

    function openMobileMenu() {
        mobileMenu.removeClass('d-none');
        setTimeout(function () { mobileMenu.removeClass('hiding'); }, 100);
    }

    function closeMobileMenu() {
        mobileMenu.addClass('hiding');
        setTimeout(function () { mobileMenu.addClass('d-none'); }, 400);
    }


    /**
     * Primary Dropdowns
     */

    let primaryHeaderRow = $('#primary-header-row'),
        primaryDropdownToggles = $('.primary-navigation-item.has-dropdown'),
        primaryDropdownOpen = false,
        primaryDropdownMenus = $('.primary-dropdown-menu');

    primaryDropdownToggles.on('click', function (e) {

        e.stopPropagation();

        if($(this).hasClass('sub-menu-opened')) {
            $(this).removeClass('sub-menu-opened');
            closeAllPrimaryDropdown();
        } else {
            primaryDropdownToggles.not($(this)).removeClass('sub-menu-opened');
            $(this).addClass('sub-menu-opened');
            closeAllPrimaryDropdown($(this).data('target'));
            openPrimaryDropdown($(this).data('target'));
        }

        checkPrimaryDropdownStatus();

    });

    $('body').on('click', function () {
        closeAllPrimaryDropdown();
        checkPrimaryDropdownStatus();
    });

    primaryDropdownMenus.on('click', function (e) {
        e.stopPropagation();
    });

    function openPrimaryDropdown(target) {
        $(target).removeClass('d-none');
        setTimeout(function () { $(target).removeClass('hiding'); }, 100);
        primaryDropdownOpen = true;
    }

    function closeAllPrimaryDropdown(exception) {
        if($(exception).length) {
            primaryDropdownMenus.not($(exception)).addClass('hiding');
            setTimeout(function () { primaryDropdownMenus.not($(exception)).addClass('d-none'); }, 310);
        } else {
            primaryDropdownMenus.addClass('hiding');
            setTimeout(function () { primaryDropdownMenus.addClass('d-none'); }, 310);
            primaryDropdownOpen = false;
            primaryDropdownToggles.removeClass('sub-menu-opened');
        }
    }

    function checkPrimaryDropdownStatus() {
        if(primaryDropdownOpen) {
            primaryHeaderRow.addClass('has-sub-menu-opened');
        } else {
            primaryHeaderRow.removeClass('has-sub-menu-opened');
        }
    }

    let detailedDropdownMenus = $('.detailed-dropdown-menu');

    if(detailedDropdownMenus.length) {
        $('body').imagesLoaded(function () {
            setTimeout(function () {
                sizeDetailedDropdownItems();
            }, 500);
        });
    }

    function sizeDetailedDropdownItems() {
        detailedDropdownMenus.each(function () {

            let heightToSet = 0,
                internalItems = $(this).find('.detailed-link');

            internalItems.css('height', '');

            internalItems.each(function () {
                // console.log($(this).actual('outerHeight'));
                // console.log($(this).actual('height'));
                // console.log($(this).attr('tabindex'));
                // console.log('------');
                if($(this).actual('height') > heightToSet) {
                    heightToSet = $(this).actual('height');
                }
            });

            setTimeout(function () {
                internalItems.css('height', heightToSet);
            }, 200);

        });
    }

}